export const calculateSupportVolume = ({
  name: type,
  toothHeight,
  toothTop,
  xyHatching,
}) => {
  switch (type) {
    case "BLOCK":
      return (
        6991.7941 -
        137.65809 * toothHeight +
        137.90833 * toothTop -
        5247.51284 * xyHatching +
        71.8333 * toothHeight * toothTop +
        43.15556 * toothHeight * xyHatching -
        117.0 * toothTop * xyHatching -
        0.004938 * toothHeight ** 2 -
        0.277778 * toothTop ** 2 +
        1281.04691 * xyHatching ** 2
      );
    case "LINE":
      return (
        3623.77256 -
        69.47302 * toothHeight +
        66.09167 * toothTop -
        2850.26494 * xyHatching +
        36.91667 * toothHeight * toothTop +
        21.02222 * toothHeight * xyHatching -
        57.0 * toothTop * xyHatching -
        0.017284 * toothHeight ** 2 +
        0.277778 * toothTop ** 2 +
        741.61975 * xyHatching ** 2
      );
    case "CONTOUR":
      return (
        3545.3279 -
        69.64716 * toothHeight +
        66.0 * toothTop -
        2661.2321 * xyHatching +
        37.0 * toothHeight * toothTop +
        21.11111 * toothHeight * xyHatching -
        56.66667 * toothTop * xyHatching -
        0.012346 * toothHeight ** 2 +
        0.555556 * toothTop ** 2 +
        666.79506 * xyHatching ** 2
      );
    case "CONES":
      return (
        777.36969 +
        725.50333 * toothHeight +
        3853.23333 * toothTop -
        1597.69062 * xyHatching -
        286.0 * toothHeight * toothTop -
        93.0 * toothHeight * xyHatching -
        561.33333 * toothTop * xyHatching -
        13.24444 * toothHeight ** 2 -
        3076.11111 * toothTop ** 2 +
        484.51358 * xyHatching ** 2
      );
    default:
      return;
  }
};

export const calculateThermalStress = ({
  name: type,
  toothHeight,
  toothTop,
  xyHatching,
}) => {
  switch (type) {
    case "BLOCK":
      return (
        6.42084e9 +
        2.17099e7 * toothHeight +
        1.33333e7 * toothTop -
        2.4448e9 * xyHatching +
        1.41667e8 * toothHeight * toothTop +
        3.33333e7 * toothHeight * xyHatching -
        1.66667e7 * toothTop * xyHatching -
        2.8642e7 * toothHeight ** 2 +
        2.63889e8 * toothTop ** 2 +
        4.80988e8 * xyHatching ** 2
      );
    case "LINE":
      return (
        1.12473e10 +
        6.48272e7 * toothHeight +
        2.20667e9 * toothTop -
        7.13657e9 * xyHatching -
        1.66667e8 * toothHeight * toothTop +
        6.44444e7 * toothHeight * xyHatching -
        3.33333e8 * toothTop * xyHatching -
        2.98765e7 * toothHeight ** 2 -
        1.55556e9 * toothTop ** 2 +
        1.86272e9 * xyHatching ** 2
      );
    case "CONTOUR":
      return (
        6.47756e9 -
        2.08025e6 * toothHeight +
        6.43333e8 * toothTop -
        3.03683e9 * xyHatching +
        9.16667e7 * toothHeight * toothTop +
        2.22222e6 * toothHeight * xyHatching -
        1.83333e8 * toothTop * xyHatching -
        1.28395e7 * toothHeight ** 2 -
        7.22222e8 * toothTop ** 2 +
        8.81975e8 * xyHatching ** 2
      );
    case "CONES":
      return (
        1.27083e11 -
        9.02523e10 * toothHeight -
        3.92625e11 * toothTop +
        2.6762e10 * xyHatching +
        9.9775e10 * toothHeight * toothTop -
        2.75233e10 * toothHeight * xyHatching -
        8.015e10 * toothTop * xyHatching +
        2.752e10 * toothHeight ** 2 +
        5.095e11 * toothTop ** 2 +
        1.55733e10 * xyHatching ** 2
      );
    default:
      return;
  }
};

export const calculateTemperature = ({
  name: type,
  toothHeight,
  toothTop,
  xyHatching,
}) => {
  switch (type) {
    case "BLOCK":
      return (
        1127.30185 -
        14.01019 * toothHeight +
        87.58333 * toothTop -
        226.57593 * xyHatching +
        22.91667 * toothHeight * toothTop -
        0.555556 * toothHeight * xyHatching +
        2.5 * toothTop * xyHatching -
        0.074074 * toothHeight ** 2 -
        141.66667 * toothTop ** 2 +
        40.59259 * xyHatching ** 2
      );
    case "LINE":
      return (
        1103.19938 -
        18.45586 * toothHeight +
        96.16667 * toothTop -
        353.0784 * xyHatching +
        14.58333 * toothHeight * toothTop +
        2.55556 * toothHeight * xyHatching -
        19.16667 * toothTop * xyHatching +
        0.617284 * toothHeight ** 2 -
        90.27778 * toothTop ** 2 +
        98.46914 * xyHatching ** 2
      );
    case "CONTOUR":
      return (
        1137.57253 -
        19.2679 * toothHeight +
        125.25 * toothTop -
        276.45802 * xyHatching +
        20.0 * toothHeight * toothTop +
        1.55556 * toothHeight * xyHatching -
        31.66667 * toothTop * xyHatching +
        0.691358 * toothHeight ** 2 -
        111.11111 * toothTop ** 2 +
        56.98765 * xyHatching ** 2
      );
    case "CONES":
      return (
        764.7787 -
        45.93333 * toothHeight +
        363.0 * toothTop -
        66.52593 * xyHatching -
        17.5 * toothHeight * toothTop +
        11.66667 * toothHeight * xyHatching -
        155.0 * toothTop * xyHatching +
        11.33333 * toothHeight ** 2 +
        83.33333 * toothTop ** 2 +
        23.7037 * xyHatching ** 2
      );
    default:
      return;
  }
};

export const calculateDisplacement = ({
  name: type,
  toothHeight,
  toothTop,
  xyHatching,
}) => {
  switch (type) {
    case "BLOCK":
      return (
        0.450624 -
        0.01122 * toothHeight +
        0.035083 * toothTop -
        0.036707 * xyHatching -
        0.010417 * toothHeight * toothTop +
        0.005222 * toothHeight * xyHatching -
        0.014167 * toothTop * xyHatching +
        0.002123 * toothHeight ** 2 +
        0.006944 * toothTop ** 2 +
        0.008494 * xyHatching ** 2
      );
    case "LINE":
      return (
        0.48002 -
        0.006101 * toothHeight +
        0.007917 * toothTop -
        0.127547 * xyHatching -
        0.016667 * toothHeight * toothTop +
        0.004444 * toothHeight * xyHatching -
        0.011667 * toothTop * xyHatching +
        0.002469 * toothHeight ** 2 +
        0.051389 * toothTop ** 2 +
        0.046321 * xyHatching ** 2
      );
    case "CONTOUR":
      return (
        0.437369 -
        0.000096 * toothHeight -
        0.015917 * toothTop -
        0.01387 * xyHatching -
        0.018333 * toothHeight * toothTop +
        0.002889 * toothHeight * xyHatching -
        0.005 * toothTop * xyHatching +
        0.00237 * toothHeight ** 2 +
        0.070833 * toothTop ** 2 +
        0.000593 * xyHatching ** 2
      );
    case "CONES":
      return (
        0.496003 -
        0.024433 * toothHeight +
        0.030333 * toothTop -
        0.027511 * xyHatching +
        0.0025 * toothHeight * toothTop +
        0.001667 * toothHeight * xyHatching -
        0.001667 * toothTop * xyHatching +
        0.004 * toothHeight ** 2 +
        8.25825e-16 * toothTop ** 2 +
        0.007111 * xyHatching ** 2
      );
    default:
      return;
  }
};
